import { render, staticRenderFns } from "./HelpAndSupport.vue?vue&type=template&id=6b036190&scoped=true"
import script from "./HelpAndSupport.vue?vue&type=script&lang=js"
export * from "./HelpAndSupport.vue?vue&type=script&lang=js"
import style0 from "./HelpAndSupport.vue?vue&type=style&index=0&id=6b036190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b036190",
  null
  
)

export default component.exports